const login = () =>
  import(/* webpackChunkName: "login" */ "@/views/login/login");
const registerGetCode = () =>
  import(
    /* webpackChunkName: "register-getCode" */ "@/views/login/register-getCode/"
  );
const registerSubmit = () =>
  import(
    /* webpackChunkName: "register-submit" */ "@/views/login/register-submit/"
  );
const registerStatus = () =>
  import(
    /* webpackChunkName: "register-status" */ "@/views/login/register-status/"
  );
const forget = () =>
  import(/* webpackChunkName: "forget" */ "@/views/login/forget/");
const forgetReset = () =>
  import(/* webpackChunkName: "forget-reset" */ "@/views/login/forget-reset/");
const forgetStatus = () =>
  import(
    /* webpackChunkName: "forget-status" */ "@/views/login/forget-status/"
  );
const autoLogin = () =>
  import(/* webpackChunkName: "auto-login" */ "@/views/login/auto-login/");
const initStorage = () =>
  import(
    /* webpackChunkName: "auto-login" */ "@/views/login/auto-login/init-storage"
  );
const agreement = () => import("@/views/login/agreement/index.vue");
const _success = () => import("@/views/login/forget/success.vue");
export default [
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/login/registerGetCode",
    name: "registerGetCode",
    component: registerGetCode
  },
  {
    path: "/login/registerSubmit",
    name: "registerSubmit",
    component: registerSubmit
  },
  {
    path: "/login/registerStatus/:status",
    name: "registerStatus",
    props: true,
    component: registerStatus
  },
  {
    path: "/login/forget/:type",
    name: "forget",
    component: forget
  },
  {
    path: "/login/forget/reset",
    name: "forgetReset",
    component: forgetReset
  },
  {
    path: "/login/forget/reset/:status",
    name: "forgetStatus",
    props: true,
    component: forgetStatus
  },
  {
    path: "/login/auto-login/:access_token/:return_url?",
    name: "autoLogin",
    props: true,
    component: autoLogin
  },
  {
    path: "/login/init-storage/:params",
    name: "initStorage",
    props: true,
    component: initStorage
  },
  {
    path: "/agreement",
    name: "agreement",
    component: agreement
  },
  {
    path: "/privacy-agreement",
    name: "privacy-agreement",
    component: () => import("@/views/login/agreement/privacy-agreement.vue")
  },
  {
    path: "/success",
    name: "success",
    component: _success
  },
  {
    path: "/identity",
    name: "identity",
    component: () => import("@/views/login/identity/identity.vue")
  },
  {
    path: "/identity/verify",
    name: "identity_verify",
    component: () => import("@/views/login/identity/verify.vue")
  },
  {
    path: "/login/sso",
    name: "sso",
    component: () => import("@/views/login/sso.vue")
  }
];
